import Duck from 'extensible-duck';
import axios from 'axios';

import { DUCKS_NAMESPACE, LOCALSTORAGE_KEY } from '../config/constants';

export default new Duck({
  namespace: DUCKS_NAMESPACE,
  store: 'auth',
  initialState: {
    isAuthenticated: false,
    isPending: false,
    isError: false,
  },

  types: [
    'LOGIN',
    'LOGIN_PENDING',
    'LOGIN_FULFILLED',
    'LOGIN_REJECTED',
    'UPDATE_AUTHENTICATION',
    'LOGOUT',
  ],

  reducer: (state, action, { types, initialState }) => {
    switch (action.type) {
      case types.LOGIN_PENDING:
        return { ...state, isPending: true };
      case types.LOGIN_FULFILLED:
        return {
          ...state,
          ...action.payload,
          isPending: false,
          isError: false,
        };
      case types.LOGIN_REJECTED:
        return { ...state, isPending: false, isError: true };
      case types.UPDATE_AUTHENTICATION:
        return {
          ...state,
          ...action.payload,
          isAuthenticated: !!action.payload.token,
        };
      case types.LOGOUT:
        return { ...state, token: undefined, isAuthenticated: false };
      default:
        return state;
    }
  },

  creators: ({ types }) => ({
    login: (email, password) => ({
      type: types.LOGIN,
      payload: axios
        .post('/api/v2/auth/authentications:login', {
          userIdentifier: email,
          password,
        })
        .then(({ data: result }) => {
          if (!result.data.roles.includes('ADMIN')) {
            throw new Error('You must be an administrator to login!');
          }
          try {
            localStorage.setItem(
              LOCALSTORAGE_KEY,
              JSON.stringify({
                token: result.data.apiKey,
                email,
              }),
            );
            console.log('Wrote auth to localStorage');
          } catch (_) {
            console.log('Could not write to localStorage');
          }
          return {
            isAuthenticated: true,
            token: result.data.apiKey,
            email,
          };
        }),
    }),
    updateAuthentication: (email, token) => ({
      type: types.UPDATE_AUTHENTICATION,
      payload: {
        email,
        token,
      },
    }),
    logout: (email) => (dispatch) => {
      try {
        localStorage.setItem(
          LOCALSTORAGE_KEY,
          JSON.stringify({
            email,
          }),
        );
      } catch (_) {
        console.log('Could not write to localStorage');
      }
      return dispatch({
        type: types.LOGOUT,
      });
    },
  }),
});
